import { useTranslation } from "react-i18next";
import { Checkbox, List } from "react-native-paper";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";

type CheckboxState = Record<string, "checked" | "unchecked">;
type Props = {
	options: string[];
	checkboxStates?: CheckboxState;
	handleSelectOption: (index: string) => void;
};

const OptionListItem = ({
	option,
	handleSelectOption,
	index,
	selected,
}: {
	option: string;
	handleSelectOption: (index: string) => void;
	index: number;
	selected?: "checked" | "unchecked" | "indeterminate";
}) => (
	<List.Item
		title={option}
		style={{
			paddingVertical: 0,
		}}
		titleNumberOfLines={2}
		onPress={() => handleSelectOption(`${index}`)}
		left={() => (
			<Checkbox.Android
				key={option}
				status={selected || "unchecked"}
				onPress={() => handleSelectOption(`${index}`)}
			/>
		)}
	/>
);

const DeleteOptions = ({
	options,
	checkboxStates,
	handleSelectOption,
}: Props) => {
	const { t } = useTranslation();

	return (
		<Box paddingVertical={16}>
			<CustomListSubheader enableGutters={false}>
				{t("account.delete.chooseReason")}
			</CustomListSubheader>
			{options.map((option, index) => (
				<OptionListItem
					key={option}
					option={option}
					handleSelectOption={handleSelectOption}
					index={index}
					selected={checkboxStates ? checkboxStates[`${index}`] : undefined}
				/>
			))}
		</Box>
	);
};

export default DeleteOptions;
